import React, { useState } from 'react';
import Slider, { Settings } from 'react-slick';
import Link from 'next/link';
import CustomImage from '@components/common/image';
import { usePassReviewBanners } from '@repository/passReview/usePassReview';
import { PassReviewBannerItemDto } from '@domain/rs/passReview/PassReviewBannerListRs';
import classnames from 'classnames/bind';
import styles from './index.module.scss';
const cx = classnames.bind(styles);

interface ItemProps {
  data: PassReviewBannerItemDto;
}

const Item = ({ data }: ItemProps) => {
  return (
    <div className={cx('bannerArea')}>
      <Link href={data.bannerLink} className={cx('imgButton')}>
        <CustomImage src={data.pcBannerImageUrl} width={1200} height={240} alt={data.name} pointer />
      </Link>
    </div>
  );
};

const PassboardBanner = () => {
  const { data } = usePassReviewBanners();
  const [currentIndex, setCurrentIndex] = useState(1);

  const settings: Settings = {
    arrows: false,
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 3000,
    afterChange: (index) => setCurrentIndex(index + 1),
  };

  if (!data || !data?.banners.length) return null;

  const bannerData = data.banners.sort((a, b) => a.priority - b.priority);
  const bannerEls = bannerData.map((banner) => <Item key={banner.sn} data={banner} />);

  return (
    <div className={cx('wrapper')}>
      <Slider {...settings}>{bannerEls}</Slider>

      <div className={cx('numbering')}>
        <span className={cx('currentIndex')}>{currentIndex}</span>
        <span className={cx('totalIndex')}>{data.banners.length}</span>
      </div>
    </div>
  );
};

export default PassboardBanner;
